module.exports = "<div v-show=show transition=popup :style={height:height} class=mui-popup> <slot></slot> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/index.vue
 ** module id = 172
 ** module chunks = 0
 **/